// Shared gameplay configuration mirroring /app/backend/gameplay.py

export const LEVEL_NAMES = {
  1: { en: 'Determination', zh: '\u51b3\u5fc3' },
  2: { en: 'Discipline', zh: '\u81ea\u5f8b' },
  3: { en: 'Perseverance', zh: '\u6bc5\u529b' },
  4: { en: 'Hard-Working', zh: '\u52e4\u52b3' },
  5: { en: 'Breakthrough', zh: '\u7a81\u7834' },
};

export const LEVEL_REQUIREMENTS = {
  1: { apprentice: 3, master: 0, legend: 0 },
  2: { apprentice: 3, master: 2, legend: 0 },
  3: { apprentice: 3, master: 5, legend: 2 },
  4: { apprentice: 3, master: 7, legend: 5 },
  5: { apprentice: 3, master: 10, legend: 7 },
};

export const LEVEL_REWARDS = {
  1: { coins: 100, xp: 50, badge: 'Determination' },
  2: { coins: 200, xp: 75, badge: 'Discipline' },
  3: { coins: 350, xp: 100, badge: 'Perseverance' },
  4: { coins: 500, xp: 150, badge: 'Hard-Working' },
  5: { coins: 1000, xp: 250, badge: 'Breakthrough' },
};

export const STAGES_PER_LEVEL = 3;

export const QUESTIONS_PER_STAGE_BY_LEVEL = {
  1: 3,
  2: 5,
  3: 10,
  4: 20,
  5: 20,
};

export const DIFFICULTY_META = {
  apprentice: { label_en: 'Apprentice', label_zh: '\u5b66\u5f92', color: 'emerald', from: 'from-emerald-400', to: 'to-emerald-600' },
  master: { label_en: 'Master', label_zh: '\u9ad8\u624b', color: 'violet', from: 'from-violet-400', to: 'to-violet-600' },
  legend: { label_en: 'Legend', label_zh: '\u4f20\u5947', color: 'amber', from: 'from-amber-400', to: 'to-orange-500' },
};

export function levelName(num, lang = 'en') {
  return LEVEL_NAMES[num]?.[lang] || `Level ${num}`;
}

export function questionsPerStage(num) {
  return QUESTIONS_PER_STAGE_BY_LEVEL[num] || QUESTIONS_PER_STAGE_BY_LEVEL[5];
}
